import { render, staticRenderFns } from "./AnnotationLayer.vue?vue&type=template&id=a5b5b0c4"
import script from "./AnnotationLayer.vue?vue&type=script&lang=js"
export * from "./AnnotationLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports